'use strict';

;(function($) {
    const mediaList = {
        'default': [null, null],
        'desk': [null, 1451],
        'lap': [1450, 1024],
        'lap-and-up': [null, 1024],
        'portable': [1023, null],
        'tablet': [1023, 680],
        'palm': [679, null]
    };

    function touch() {
        // https://developer.mozilla.org/en-US/docs/Web/API/Navigator/maxTouchPoints
        return 'ontouchstart' in window || navigator.MaxTouchPoints > 0 || navigator.msMaxTouchPoints > 0;
    }

    function viewport(size) {
        let winObj = window;
        let mode = 'inner';

        if ('innerWidth' in window || (mode = 'client',
            winObj = document.documentElement || document.body),
            size) {
            if (mediaList[size]) {
                return (winObj[mode + 'Width'] <= mediaList[size][0] || null == mediaList[size][0]) && (winObj[mode + 'Width'] >= mediaList[size][1] || null === mediaList[size][1]);
            }

            if ('>' === size.slice(0, 1) && mediaList[size.slice(1)]) {
                return winObj[mode + 'Width'] >= mediaList[size.slice(1)][1] || null === mediaList[size.slice(1)][1];
            }

            if ('<' === size.slice(0, 1) && mediaList[size.slice(1)]) {
                return winObj[mode + 'Width'] <= mediaList[size.slice(1)][0] || null === mediaList[size.slice(1)][0];
            }

            if ('touch' === size) {
                return touch();
            }

            throw 'Media size ' + size + ' not found in media list.'
        }

        return {
            width: winObj[mode + 'Width'],
            height: winObj[mode + 'Height']
        }
    }

    function heroVideo(mode) {
        const video = document.querySelector('[data-nezzo-header-video]');

        if (video) {
            const sources = document.querySelectorAll('[data-nezzo-header-video] source[data-nezzo-video-type="' + mode + '"]');


            for (let i = 0; i < sources.length; i++) {
                sources[i].setAttribute('src', sources[i].getAttribute('data-video'));
                // sources[i].parentElement.load();
            }

            video.load();
        }
    }

    document.addEventListener('DOMContentLoaded', () => {
        if (viewport('lap-and-up')) {
            heroVideo('desktop');
        } else {
            heroVideo('mobile');
        }
    });

    window.addEventListener('resize', () => {
        if (viewport('lap-and-up')) {
            const video = document.querySelector('[data-nezzo-header-video]');

            if (video && document.querySelector('[data-nezzo-header-video] source').src.length <= 0) {
                heroVideo('desktop');
            } else {
                heroVideo('mobile');
            }
        }
    });

}($));
